import { useEffect, useRef } from 'react';

/**
 * A hook that calls a callback function at a specified interval. Clears the interval when the component unmounts.
 * Throws an error if the delay is NaN.
 */
export function useInterval(callback: () => void, delay: number | null) {
    if (Number.isNaN(delay)) {
        throw new Error('delay is NaN');
    }
    const savedCallback = useRef<() => void>();

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // eslint-disable-next-line consistent-return -- intentional,
    useEffect(() => {
        const tick = () => {
            if (savedCallback.current) {
                savedCallback.current();
            }
        };
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}
